import * as React from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

import Notification from 'components/notification/Notification';
import PageSubnavigation from './page-subnavigation/PageSubnavigation';

import './page.scss';

import type { NavigationNavItem, Notification as NotificationAlias } from 'types';
import type { Dispatch } from 'redux';

type OwnProps = {
  documentTitle: string,
  children: React.ReactNode | undefined | null,
  topBlock?: React.ReactNode | null,
  infoNote?: React.ReactNode,
  subnavigation?: Array<NavigationNavItem> | null,
  customStyle?: {
    [x: string]: unknown
  },
  subnavigationClassName?: string
};

type StateProps = {
  language: string,
  notification: NotificationAlias
};

type Props = {
  // eslint-disable-next-line react/no-unused-prop-types
  dispatch: Dispatch // added by connect, so we should keep it here
} & OwnProps & StateProps;

class Page extends React.PureComponent<Props> {
  static defaultProps = {
    subnavigationClassName: ''
  };

  render(): React.ReactNode {
    const {
      documentTitle,
      language,
      notification,
      topBlock,
      infoNote,
      children,
      customStyle,
      subnavigation,
      subnavigationClassName
    } = this.props;

    return (
      <React.Fragment>
        <Helmet>
          <title>{documentTitle}</title>
        </Helmet>
        <main
          key={language}
          className="page"
        >
          {
            subnavigation && (
              <div className={subnavigationClassName}>
                <PageSubnavigation
                  key={`subnavigation-${Math.random()}`}
                  items={subnavigation}
                />
              </div>
            )
          }
          <Notification
            key={notification.type}
          />
          <div className="layout-container">
            {infoNote}
            {
              topBlock && (
                <div className="page__top-block">
                  {topBlock}
                </div>
              )
            }
            <div
              className="page__content"
              style={customStyle}
            >
              {children}
            </div>
          </div>
        </main>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ common }): StateProps => ({
  language: common.language,
  notification: common.notification
});

export default connect(mapStateToProps)(Page);
